export enum StatusEnums {
  AWAITING = 'awaiting',
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  DENIED = 'denied',
  SUCCESS = 'success',
  ERROR = 'error',
}
